const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getLoopsQueryOptions } from '@/lib/queries/common/useLoopsQuery';
import { readStoredLoopId } from '@/lib/utils/loop/selectLoop';
export const Route = createFileRoute('/(app)/org/$org/')({
  staticData: {
    hideLoopNav: true
  },
  beforeLoad: async ({
    context: {
      queryClient,
      organizationId
    },
    params: {
      org
    }
  }) => {
    const loops = await queryClient.ensureQueryData(getLoopsQueryOptions(organizationId ?? ''));
    const firstLoop = loops.data[0];
    const isOnlyLoopInOrg = loops.data.length === 1;
    if (firstLoop && isOnlyLoopInOrg) {
      throw redirect({
        to: '/org/$org/loop/$loopId',
        params: {
          org,
          loopId: firstLoop.id
        },
        replace: true
      });
    }
    const storedLoopId = readStoredLoopId();
    const lastVisitedLoop = storedLoopId ? loops.data.find(loop => loop.id === storedLoopId && loop.organizationId === organizationId) : undefined;
    if (lastVisitedLoop) {
      throw redirect({
        to: '/org/$org/loop/$loopId',
        params: {
          org,
          loopId: lastVisitedLoop.id
        },
        replace: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});